import { useDebounce } from 'usehooks-ts';

import { useAppSelector } from '../../hooks';
import { RootState } from '../../store';

export const useGetCodeSearch = () =>
  useAppSelector((state: RootState) => state.codeSearchSlice);

export const useGetDebouncedCodeSearch = (delay: number) => {
  const value = useGetCodeSearch();

  return useDebounce(value, delay);
};

export const useGetTextSearch = () =>
  useAppSelector((state: RootState) => state.codeSearchSlice.text);
